import { render, staticRenderFns } from "./DesignDetail.vue?vue&type=template&id=50d3dfca&scoped=true"
import script from "./DesignDetail.vue?vue&type=script&lang=js"
export * from "./DesignDetail.vue?vue&type=script&lang=js"
import style0 from "./DesignDetail.vue?vue&type=style&index=0&id=50d3dfca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3dfca",
  null
  
)

export default component.exports